import styled from '@emotion/styled/macro';

export const Container = styled.div`
  padding: 30px;
  background-color: #f5f6f8;
  min-height: 100vh;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #444;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
`;

export const Button = styled.button`
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background-color: #3b78e7;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ContentWrapper = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 20px;
  margin-top: 20px;
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Input = styled.input`
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

export const SelectContainer = styled.div`
  position: relative;
`;

export const Select = styled.select`
  appearance: none;
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
`;

export const SelectArrow = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`;

export const Textarea = styled.textarea`
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-height: 80px;
  resize: vertical;
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const QuestionItem = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #4285f4;
  border-radius: 4px;
  background-color: ${({ isChecked }) => (isChecked ? '#4285f4' : 'white')};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
`;

export const AddQuestionButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #4285f4;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  align-self: center;
  margin-top: 10px;

  &:hover {
    background-color: #3b78e7;
  }
`;
